module.exports = __webpack_public_path__ + "static/media/dockIo.b7dd86c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners/images/dockIo.png
// module id = 1848
// module chunks = 146